<template>
  <div>
    <div class="container">

      <div class="columns mt-01">

        <div class="column">
          <img src="assets/img/convenios_mayo_2023.jpeg?v=1.2.1"/>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Convenios',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Convenios.vue